import Welcome from "../components/Welcome/Welcome";
import { Header } from "../components/Header/Header";

export function WelcomePage () {
    return (
        <>
            <Header />
            <Welcome />
        </>
    )
}